import { usePergolaConfigurationsApi } from "../api/pergola_configuration_api";
import { GenericRequestResult } from "../core/common_types";
import {  Accessorio, DoorConfig, DoorConfigurationConditions, QuoteSummary,} from "../models/door_configuration";
import { Aperture, AspectPergola, DimensionPergola, DimensionPergolaLoad, EmailRilievo, Fioriere, LatoIlluminazioneFaretto, MuroPergola, PergolaConfiguration, Pilastri, Rilievo, Tubolare, VetroType } from "../models/pergola_configuration";
import { User } from "../models/user";
import { ClosuresApiResponse } from "../routes/configurations/pergola/builder/components/forms/Pergola_type";
import { LatoIlluminazioneLed, LatoPergola } from "../routes/configurations/pergola/builder/components/pergola-draw/Pergola";

export const useConfigurationsServicePergola = () => {
    const PergolaConfigurationsApi = usePergolaConfigurationsApi();
    return{  
        async updateDimensionsPergola(currentUser: User, configurationId: number, model: DimensionPergola): Promise<any> {
            let result = await PergolaConfigurationsApi.putDimensions(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data;
        },
        async getQuote(currentUser: User, configurationId: number): Promise<QuoteSummary> {
            let result = await PergolaConfigurationsApi.getQuote(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data as QuoteSummary;
        },
        async sendRilievoPergola(currentUser: User, configurationId: number, model: EmailRilievo): Promise<any> {
            let result = await PergolaConfigurationsApi.sendRilievo(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data;
        },
        async aggiornaCondizioni(currentUser: User, configurationId: number, data: DoorConfigurationConditions): Promise<DoorConfigurationConditions> {
            let result = await PergolaConfigurationsApi.updateConditions(currentUser, configurationId, data);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfigurationConditions;
        },
        async updateAspect(currentUser: User, configurationId: number, model: AspectPergola): Promise<DoorConfig> {
            let result = await PergolaConfigurationsApi.putAspect(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async putImagePdf(currentUser: User, configurationId: number, model: FormData): Promise<DoorConfig> {
            let result = await PergolaConfigurationsApi.putImagePdf(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async putImageDetail(currentUser: User, configurationId: number, model: FormData): Promise<DoorConfig> {
            let result = await PergolaConfigurationsApi.putImageDetail(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async build(currentUser: User, configurationId: number): Promise<any> {
            let result = await PergolaConfigurationsApi.build(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data;
        },

        async updateChiusure(currentUser: User, configurationId: number, model: {chiusure: LatoPergola[]}): Promise<DoorConfig> {
            let result = await PergolaConfigurationsApi.putChiusure(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async updateFioriere(currentUser: User, configurationId: number, model: {fioriere: Fioriere[]}): Promise<DoorConfig> {
            let result = await PergolaConfigurationsApi.putFioriere(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async updateTubolari(currentUser: User, configurationId: number, model: {tubolari: Tubolare[]}): Promise<any> {
            let result = await PergolaConfigurationsApi.putTubolari(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async getVieMaia(currentUser: User, configurationId: number, model: {width: number,heigth: number,tipo_vetro: VetroType,apertura: Aperture}): Promise<any> {
            let result = await PergolaConfigurationsApi.getVieMaia(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async updateIlluminazine(currentUser: User, configurationId: number, model: {ledAttive: LatoIlluminazioneLed[], faretti: LatoIlluminazioneFaretto}): Promise<DoorConfig> {
            let result = await PergolaConfigurationsApi.putIlluminazione(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async setCondizioni(currentUser: User, configurationId: number, data: DoorConfigurationConditions): Promise<DoorConfigurationConditions> {
            let result = await PergolaConfigurationsApi.setConditions(currentUser, configurationId, data);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfigurationConditions;
        },
        async loadDoorConfiguration(currentUser: User, configurationId: number): Promise<DimensionPergolaLoad> {
            let result = await PergolaConfigurationsApi.get(currentUser, configurationId);
            
            if (!result.success) {
                throw result.message;
            }

            if (!result.data) throw "Configuration is null";

            return result.data;
        },
        async updatePilastri(currentUser: User, configurationId: number, model: {pilastri: Pilastri[]}): Promise<DoorConfig> {
            let result = await PergolaConfigurationsApi.putPilastri(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async updateMuri(currentUser: User, configurationId: number, model: {muri: MuroPergola[]}): Promise<DoorConfig> {
            let result = await PergolaConfigurationsApi.putMuri(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async updateForma(currentUser: User, configurationId: number, model: string): Promise<any> {
            let result = await PergolaConfigurationsApi.putForma(currentUser, configurationId, model);

            if (!result.success) {
                throw result.message;
            }

            return result.data as DoorConfig; 
        },
        async getChiusure(currentUser: User, configurationId: number): Promise<LatoPergola[]> {
            let result = await PergolaConfigurationsApi.getChiusure(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data as LatoPergola[];
        },
        async getClosuresAcc(currentUser: User, configurationId: number): Promise<ClosuresApiResponse> {
            let result = await PergolaConfigurationsApi.getClosuresAcc(currentUser, configurationId);

            return result;
        },
        async getMuri(currentUser: User, configurationId: number): Promise<MuroPergola[]> {
            let result = await PergolaConfigurationsApi.getMuri(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data as MuroPergola[];
        },
        async getPilastri(currentUser: User, configurationId: number): Promise<Pilastri[]> {
            let result = await PergolaConfigurationsApi.getPilastri(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data as Pilastri[];
        },
        async getTubolari(currentUser: User, configurationId: number): Promise<Tubolare[]> {
            let result = await PergolaConfigurationsApi.getTubolari(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data as Tubolare[];
        },
        async getRilievo(currentUser: User, configurationId: number): Promise<Rilievo> {
            let result = await PergolaConfigurationsApi.getRilievo(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data as Rilievo;
        },
        async getNeedExtra(currentUser: User, configurationId: number, larghezzaSoletta: number,lunghezzaSoletta: number): Promise<boolean> {
            let result = await PergolaConfigurationsApi.getNeedTrave(currentUser, configurationId,larghezzaSoletta,lunghezzaSoletta);

            if (!result.success) {
                throw result.message;
            }

            return result.data as boolean;
        },
        async findGenericAccessoriesPergola(currentUser: User, configurationId: number): Promise<Accessorio[]> {
            let result = await PergolaConfigurationsApi.findGenericAccessoriesPergola(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }
            
            return result.data as Accessorio[];
        },
        async getIlluminazioni(currentUser: User, configurationId: number): Promise<LatoIlluminazioneLed[]> {
            let result = await PergolaConfigurationsApi.getIlluminazioni(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data as LatoIlluminazioneLed[];
        },
        async getFioriere(currentUser: User, configurationId: number): Promise<Fioriere[]> {
            let result = await PergolaConfigurationsApi.getFioriere(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data as Fioriere[];
        },
        async getForma(currentUser: User, configurationId: number): Promise<string> {
            let result = await PergolaConfigurationsApi.getForma(currentUser, configurationId);

            if (!result.success) {
                throw result.message;
            }

            return result.data as string;
        },
    };  
}